module.exports = __webpack_public_path__ + "static/img/6.753e354.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/version/03/6.png
// module id = W42E
// module chunks = 1